import { IDayCell } from './calendar'
import { ICustomOccasion, repeatsOn } from './occasion-repeat'
import events from './events'
import { eventOccasion, occasionEvent } from './occasion-event'

export type { Repeat, Reminder, ICustomOccasion } from './occasion-repeat'

// A calendar-specific view of events, never a separate storage collection.
const all = (): ICustomOccasion[] => events.all().map(eventOccasion)
    .filter((o): o is ICustomOccasion => !!o)

const forDay = (cell: IDayCell) => all().filter(o => repeatsOn(o, cell))
const byId = (id: string) => all().find(o => o.id === id)
    || all().find(o => events.byId(o.id)?.legacyOccasionId === id)
const sources = () => all().map(o => o.source).filter((s): s is string => !!s)

function add(occasion: Omit<ICustomOccasion, 'id'>): ICustomOccasion {
    const { id: _id, ...event } = occasionEvent({ ...occasion, id: '' })
    return eventOccasion(events.add(event))!
}

function update(id: string, patch: Pick<ICustomOccasion, 'title' | 'repeat' | 'reminder'>) {
    const old = byId(id)
    if (!old) return
    const { id: _id, ...event } = occasionEvent({ ...old, ...patch })
    events.update(old.id, event)
}

const remove = (id: string) => {
    const old = byId(id)
    if (old) events.remove(old.id)
}

export default { forDay, byId, sources, all, add, update, remove }
